// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"368":"confirm","845":"profile","953":"foods"}[chunkId] || chunkId) + "." + {"93":"73312324","153":"bad5ae82","368":"4d28eaa5","431":"8215dc90","565":"e3bf3f9c","845":"94229197","858":"f5ebf5d2","891":"52067b81","953":"44d0d4a2"}[chunkId] + ".js";
};